
export const hasPermission = (user, permission, orgId) => {
  if(user == null)
    return false;
  if(!!user.isSuperUser)
    return true;
  if(user.userRoles == null)
    return false;
  const orgRole = user.userRoles.find(u => u.orgId == orgId);
  if(orgRole == null)
    return false;
  if(orgRole.roleId == 2)
    return true;
  return orgRole.permissionIds?.includes(permission) ?? false;
};
